import type { FC } from 'react'

import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

import { MyListIcon } from '../MyListIcon'

interface Props {
  myList: boolean
  onFilterChange: (filter: any, submit?: boolean) => void
}

export const FilterMyList: FC<Props> = ({ myList, onFilterChange }) => {
  return (
    <Tooltip title={`Mijn lijst ${myList ? 'uit' : 'aan'}zetten`}>
      <IconButton
        data-testid="MyListButton"
        onClick={() => onFilterChange({ myList: !myList }, true)}
      >
        <MyListIcon active={myList} />
      </IconButton>
    </Tooltip>
  )
}
